import React, {useEffect} from 'react';
import {useTitle} from "../../../contexts/title";
import ChangeOrderGrid from '../../../features/cfi/change-order-grid/components/ChangeOrderGrid';

export default function ChangeOrdersPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Pending Change Orders')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<ChangeOrderGrid />
			</div>
		</React.Fragment>
	)
} 
